export interface VideoItem {
  id: string;
  title: string;
  type: "电影" | "电视剧" | "短视频";
  year: number;
  region: string;
  duration: string;
  description: string;
  cover: string;
  publishDate: string;
  hot: number;
  featured?: boolean;
}

export const videos: VideoItem[] = [
  // ==================== 电影 ====================
  {
    id: "movie-01",
    title: "星际远征",
    type: "电影",
    year: 2025,
    region: "欧美",
    duration: "02:18:00",
    description: "一支远征舰队穿越星云寻找新的家园，在深空中遭遇未知文明的考验。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20cover%2C%20a%20lone%20silver%20spaceship%20drifting%20through%20a%20glowing%20orange%20and%20teal%20nebula%2C%20deep%20space%20stars%2C%20dramatic%20rim%20lighting%2C%20epic%20scale%2C%20dark%20moody%20background%2C%20film%20grain&width=640&height=360&seq=movie-01&orientation=landscape",
    publishDate: "2026-09-28",
    hot: 9820,
    featured: true,
  },
  {
    id: "movie-02",
    title: "迷雾之城",
    type: "电影",
    year: 2024,
    region: "内地",
    duration: "01:56:00",
    description: "一座被浓雾笼罩的城市里，一段被尘封的往事随着线索逐渐浮出水面。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20cover%2C%20a%20foggy%20modern%20city%20skyline%20at%20night%2C%20neon%20reflections%20on%20wet%20streets%2C%20a%20mysterious%20silhouette%20in%20the%20mist%2C%20cool%20teal%20tones%20with%20warm%20orange%20highlights%2C%20dark%20moody%20background&width=640&height=360&seq=movie-02&orientation=landscape",
    publishDate: "2026-09-20",
    hot: 8610,
  },
  {
    id: "movie-03",
    title: "深海回响",
    type: "电影",
    year: 2025,
    region: "欧美",
    duration: "02:05:00",
    description: "深海探索队在万米海沟中发现了一段来自海洋深处神秘的回响。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20cover%2C%20a%20deep%20ocean%20trench%20with%20a%20glowing%20submarine%2C%20shafts%20of%20light%20from%20the%20surface%2C%20dark%20blue-green%20water%2C%20mysterious%20atmosphere%2C%20film%20grain&width=640&height=360&seq=movie-03&orientation=landscape",
    publishDate: "2026-08-30",
    hot: 8200,
    featured: true,
  },
  {
    id: "movie-04",
    title: "沙丘旅人",
    type: "电影",
    year: 2023,
    region: "欧美",
    duration: "02:32:00",
    description: "无垠沙海之上，一位孤独的旅人踏上寻找绿洲与真相的漫长征途。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20desert%20adventure%20cover%2C%20endless%20golden%20sand%20dunes%20under%20a%20vast%20sky%2C%20a%20lone%20wanderer%20in%20flowing%20robes%2C%20warm%20amber%20light%2C%20epic%20wide%20composition%2C%20dark%20moody%20background&width=640&height=360&seq=movie-04&orientation=landscape",
    publishDate: "2026-08-12",
    hot: 7940,
  },
  {
    id: "movie-05",
    title: "都市夜归人",
    type: "电影",
    year: 2024,
    region: "港台",
    duration: "01:48:00",
    description: "午夜的城市街头，几个素不相识的人因一场意外彼此命运交叠。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20cover%2C%20a%20rain-soaked%20city%20street%20at%20midnight%2C%20a%20figure%20walking%20under%20warm%20street%20lamps%2C%20orange%20glow%20against%20cool%20dark%20tones%2C%20moody%20atmosphere&width=640&height=360&seq=movie-05&orientation=landscape",
    publishDate: "2026-07-25",
    hot: 7630,
  },
  {
    id: "movie-06",
    title: "追风少年",
    type: "电影",
    year: 2022,
    region: "内地",
    duration: "01:42:00",
    description: "一个热爱奔跑的少年，用一场比赛改变了自己与家人的命运。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20coming-of-age%20cover%2C%20a%20young%20runner%20sprinting%20across%20an%20open%20field%20at%20golden%20hour%2C%20warm%20sunlight%20flare%2C%20motion%20blur%2C%20hopeful%20atmosphere%2C%20dark%20moody%20tones&width=640&height=360&seq=movie-06&orientation=landscape",
    publishDate: "2026-07-10",
    hot: 6890,
  },
  {
    id: "movie-07",
    title: "极地密码",
    type: "电影",
    year: 2025,
    region: "欧美",
    duration: "02:11:00",
    description: "一支科考队深入极地冰原，解开冰层之下隐藏的古老秘密。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20cover%2C%20a%20frozen%20arctic%20landscape%20with%20a%20lone%20expedition%20tent%2C%20aurora%20lights%20in%20the%20sky%2C%20cold%20blue%20tones%20with%20warm%20orange%20lantern%20glow%2C%20dramatic%20scale&width=640&height=360&seq=movie-07&orientation=landscape",
    publishDate: "2026-06-28",
    hot: 9120,
    featured: true,
  },
  {
    id: "movie-08",
    title: "无声证词",
    type: "电影",
    year: 2023,
    region: "日韩",
    duration: "01:59:00",
    description: "在一间昏暗的审讯室里，沉默与证词之间只隔着一线真相。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20cover%2C%20a%20dim%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20harsh%20shadows%2C%20muted%20teal%20and%20amber%20palette%2C%20tense%20atmosphere%2C%20film%20grain&width=640&height=360&seq=movie-08&orientation=landscape",
    publishDate: "2026-06-15",
    hot: 6510,
  },
  {
    id: "movie-09",
    title: "时光信笺",
    type: "电影",
    year: 2024,
    region: "内地",
    duration: "01:37:00",
    description: "一封迟到多年的信，让两个错过的人重新想起那个夏天。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20cover%2C%20a%20vintage%20desk%20with%20old%20letters%20and%20a%20warm%20lamp%2C%20soft%20golden%20light%2C%20nostalgic%20mood%2C%20shallow%20depth%20of%20field%2C%20dark%20moody%20background&width=640&height=360&seq=movie-09&orientation=landscape",
    publishDate: "2026-05-30",
    hot: 6020,
  },
  {
    id: "movie-10",
    title: "暗涌",
    type: "电影",
    year: 2025,
    region: "港台",
    duration: "01:53:00",
    description: "平静的水面之下暗流涌动，一场关于抉择与代价的较量悄然展开。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20noir%20cover%2C%20a%20lone%20figure%20on%20a%20pier%20at%20night%2C%20rippling%20dark%20water%2C%20distant%20city%20lights%2C%20cool%20teal%20shadows%20with%20orange%20highlights%2C%20mysterious%20atmosphere&width=640&height=360&seq=movie-10&orientation=landscape",
    publishDate: "2026-05-18",
    hot: 7390,
  },
  {
    id: "movie-11",
    title: "末路狂花",
    type: "电影",
    year: 2021,
    region: "欧美",
    duration: "02:04:00",
    description: "一辆旧敞篷车、一条没有尽头的公路，和两个想要逃离一切的人。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20road%20movie%20cover%2C%20a%20vintage%20convertible%20speeding%20down%20a%20desert%20highway%20at%20sunset%2C%20dust%20trail%2C%20warm%20orange%20sky%2C%20dynamic%20composition%2C%20film%20grain&width=640&height=360&seq=movie-11&orientation=landscape",
    publishDate: "2026-05-02",
    hot: 5680,
  },
  {
    id: "movie-12",
    title: "山海秘境",
    type: "电影",
    year: 2024,
    region: "内地",
    duration: "01:46:00",
    description: "云雾缭绕的群山之间，一座被遗忘的古庙藏着远古的传说。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20cover%2C%20misty%20ancient%20mountains%20with%20floating%20lanterns%2C%20a%20hidden%20temple%20in%20the%20cliffs%2C%20warm%20amber%20light%20with%20teal%20mist%2C%20epic%20scale&width=640&height=360&seq=movie-12&orientation=landscape",
    publishDate: "2026-04-22",
    hot: 6880,
  },
  {
    id: "movie-13",
    title: "雪线之上",
    type: "电影",
    year: 2023,
    region: "欧美",
    duration: "02:21:00",
    description: "一群登山者向着雪线发起挑战，也在极限中重新认识彼此。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mountaineering%20cover%2C%20climbers%20on%20a%20snow-covered%20ridge%2C%20dramatic%20alpine%20light%2C%20cold%20blue%20tones%20with%20warm%20sunrise%20glow%2C%20epic%20wide%20shot&width=640&height=360&seq=movie-13&orientation=landscape",
    publishDate: "2026-04-08",
    hot: 6210,
  },
  {
    id: "movie-14",
    title: "重逢之日",
    type: "电影",
    year: 2022,
    region: "日韩",
    duration: "01:39:00",
    description: "多年后的站台上，两个人不约而同地想起了当初道别的那个黄昏。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20cover%2C%20two%20silhouettes%20meeting%20on%20a%20train%20platform%20at%20dusk%2C%20warm%20golden%20light%2C%20soft%20bokeh%2C%20emotional%20atmosphere%2C%20dark%20moody%20tones&width=640&height=360&seq=movie-14&orientation=landscape",
    publishDate: "2026-03-26",
    hot: 5470,
  },
  {
    id: "movie-15",
    title: "铁血航线",
    type: "电影",
    year: 2025,
    region: "欧美",
    duration: "02:27:00",
    description: "在风暴笼罩的海域，一艘孤舰肩负着全船人的信念破浪前行。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20cover%2C%20a%20warship%20cutting%20through%20stormy%20seas%20at%20dawn%2C%20dramatic%20clouds%2C%20cool%20teal%20water%20with%20orange%20sky%2C%20epic%20scale%2C%20film%20grain&width=640&height=360&seq=movie-15&orientation=landscape",
    publishDate: "2026-03-12",
    hot: 8760,
    featured: true,
  },
  {
    id: "movie-16",
    title: "城中谜案",
    type: "电影",
    year: 2024,
    region: "内地",
    duration: "01:51:00",
    description: "旧城区接连发生的怪事，让一位普通调查员卷入了层层谜团。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20cover%2C%20a%20rainy%20city%20alley%20with%20a%20single%20glowing%20doorway%2C%20wet%20cobblestones%2C%20teal%20shadows%20and%20warm%20orange%20light%2C%20moody%20atmosphere&width=640&height=360&seq=movie-16&orientation=landscape",
    publishDate: "2026-03-01",
    hot: 6640,
  },
  {
    id: "movie-17",
    title: "星光旅店",
    type: "电影",
    year: 2023,
    region: "港台",
    duration: "01:44:00",
    description: "公路边一间小小的旅店，来来往往的旅人留下了各自的故事。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20cover%2C%20a%20cozy%20roadside%20motel%20at%20night%20under%20a%20starry%20sky%2C%20warm%20window%20glow%2C%20cool%20dark%20surroundings%2C%20nostalgic%20mood&width=640&height=360&seq=movie-17&orientation=landscape",
    publishDate: "2026-02-18",
    hot: 5120,
  },
  {
    id: "movie-18",
    title: "荒野回声",
    type: "电影",
    year: 2025,
    region: "欧美",
    duration: "02:09:00",
    description: "在无人的峡谷里，一个孤独的身影循着回声寻找归途。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20western%20cover%2C%20a%20vast%20canyon%20landscape%20at%20golden%20hour%2C%20a%20lone%20rider%20silhouette%2C%20warm%20amber%20light%2C%20epic%20wide%20composition%2C%20film%20grain&width=640&height=360&seq=movie-18&orientation=landscape",
    publishDate: "2026-02-06",
    hot: 7260,
  },
  {
    id: "movie-19",
    title: "昨日晴空",
    type: "电影",
    year: 2024,
    region: "日韩",
    duration: "01:58:00",
    description: "澄澈的夏日天空下，一段青春的记忆被悄悄珍藏。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20cover%2C%20a%20rooftop%20under%20a%20bright%20summer%20sky%20with%20soft%20clouds%2C%20warm%20sunlight%2C%20gentle%20nostalgic%20mood%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=movie-19&orientation=landscape",
    publishDate: "2026-01-24",
    hot: 5980,
  },
  {
    id: "movie-20",
    title: "雷霆行动",
    type: "电影",
    year: 2022,
    region: "内地",
    duration: "02:02:00",
    description: "一场横跨全城的追捕行动，在霓虹闪烁的夜色中高速展开。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20cover%2C%20a%20high-speed%20car%20chase%20through%20a%20night%20city%2C%20motion%20blur%20light%20trails%2C%20orange%20and%20teal%20palette%2C%20dynamic%20dramatic%20angle&width=640&height=360&seq=movie-20&orientation=landscape",
    publishDate: "2026-01-12",
    hot: 6420,
  },
  {
    id: "movie-21",
    title: "云端之上",
    type: "电影",
    year: 2025,
    region: "欧美",
    duration: "01:55:00",
    description: "驾驶着热气球飞越云海，一场关于自由与勇气的旅程就此启程。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20cover%2C%20a%20hot%20air%20balloon%20floating%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20warm%20golden%20light%2C%20epic%20sky%20composition%2C%20soft%20haze&width=640&height=360&seq=movie-21&orientation=landscape",
    publishDate: "2026-01-03",
    hot: 7050,
  },

  // ==================== 电视剧 ====================
  {
    id: "tv-01",
    title: "长夜将明",
    type: "电视剧",
    year: 2025,
    region: "内地",
    duration: "45:00",
    description: "一桩旧案牵连出新的线索，一群人在长夜中守候黎明。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20cover%2C%20a%20lone%20detective%20standing%20under%20rain%20in%20a%20dark%20alley%2C%20warm%20street%20lamp%20glow%2C%20cool%20teal%20shadows%2C%20moody%20atmosphere%2C%20film%20grain&width=640&height=360&seq=tv-01&orientation=landscape",
    publishDate: "2026-09-25",
    hot: 9540,
    featured: true,
  },
  {
    id: "tv-02",
    title: "都市浮生记",
    type: "电视剧",
    year: 2024,
    region: "内地",
    duration: "42:00",
    description: "高楼林立之间，几个年轻人的奋斗与聚散每天都在上演。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20TV%20drama%20cover%2C%20a%20bustling%20city%20intersection%20at%20dusk%2C%20glowing%20windows%2C%20warm%20orange%20and%20cool%20teal%20tones%2C%20cinematic%20wide%20shot&width=640&height=360&seq=tv-02&orientation=landscape",
    publishDate: "2026-09-10",
    hot: 8320,
  },
  {
    id: "tv-03",
    title: "沉默的证词",
    type: "电视剧",
    year: 2025,
    region: "港台",
    duration: "44:00",
    description: "在堆积如山的卷宗里，真相往往藏在一句最不起眼的话中。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20series%20cover%2C%20a%20dim%20office%20with%20scattered%20case%20files%20and%20a%20single%20lamp%2C%20harsh%20shadows%2C%20muted%20amber%20and%20teal%20palette%2C%20tense%20mood&width=640&height=360&seq=tv-03&orientation=landscape",
    publishDate: "2026-08-26",
    hot: 7890,
  },
  {
    id: "tv-04",
    title: "东京物语新篇",
    type: "电视剧",
    year: 2023,
    region: "日韩",
    duration: "46:00",
    description: "夜色中的街巷与灯火，见证着平凡生活里的温暖片段。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20series%20cover%2C%20a%20quiet%20Tokyo%20street%20at%20night%20with%20glowing%20signs%2C%20soft%20bokeh%2C%20warm%20orange%20against%20cool%20dark%20tones%2C%20intimate%20atmosphere&width=640&height=360&seq=tv-04&orientation=landscape",
    publishDate: "2026-08-05",
    hot: 6980,
  },
  {
    id: "tv-05",
    title: "王座之影",
    type: "电视剧",
    year: 2024,
    region: "欧美",
    duration: "52:00",
    description: "烛光摇曳的石厅之中，权力、忠诚与野心不断交锋。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20historical%20series%20cover%2C%20a%20candle-lit%20stone%20hall%20with%20a%20lone%20throne%2C%20dramatic%20shadows%2C%20warm%20amber%20light%20with%20deep%20teal%20darkness%2C%20epic%20scale&width=640&height=360&seq=tv-05&orientation=landscape",
    publishDate: "2026-07-20",
    hot: 8110,
  },
  {
    id: "tv-06",
    title: "青春交响曲",
    type: "电视剧",
    year: 2022,
    region: "内地",
    duration: "40:00",
    description: "校园里的一群伙伴，用音乐和友谊谱写属于他们的青春。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20series%20cover%2C%20a%20group%20of%20friends%20on%20a%20school%20rooftop%20at%20sunset%2C%20warm%20golden%20light%2C%20joyful%20atmosphere%2C%20soft%20lens%20flare&width=640&height=360&seq=tv-06&orientation=landscape",
    publishDate: "2026-07-02",
    hot: 6240,
  },
  {
    id: "tv-07",
    title: "迷雾侦探",
    type: "电视剧",
    year: 2025,
    region: "欧美",
    duration: "48:00",
    description: "雾气弥漫的港口城市里，一位侦探循着线索抽丝剥茧。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20cover%2C%20a%20foggy%20harbour%20with%20a%20silhouetted%20figure%2C%20cold%20teal%20tones%20with%20a%20warm%20lantern%2C%20mysterious%20mood%2C%20film%20grain&width=640&height=360&seq=tv-07&orientation=landscape",
    publishDate: "2026-06-18",
    hot: 7730,
  },
  {
    id: "tv-08",
    title: "医者仁心",
    type: "电视剧",
    year: 2024,
    region: "内地",
    duration: "43:00",
    description: "清晨的医院走廊里，一个个关于生命与守护的故事静静发生。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20cover%2C%20a%20hospital%20corridor%20at%20dawn%20with%20warm%20light%2C%20clean%20moody%20tones%2C%20hopeful%20atmosphere%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=tv-08&orientation=landscape",
    publishDate: "2026-06-01",
    hot: 6580,
  },
  {
    id: "tv-09",
    title: "星尘舰队",
    type: "电视剧",
    year: 2023,
    region: "欧美",
    duration: "55:00",
    description: "在遥远的星系，一支舰队守护着通往未知世界的航路。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20space%20opera%20cover%2C%20a%20fleet%20of%20starships%20near%20a%20glowing%20planet%2C%20deep%20space%20nebula%2C%20epic%20scale%2C%20orange%20and%20teal%20lighting%2C%20film%20grain&width=640&height=360&seq=tv-09&orientation=landscape",
    publishDate: "2026-05-22",
    hot: 7420,
  },
  {
    id: "tv-10",
    title: "街角咖啡屋",
    type: "电视剧",
    year: 2025,
    region: "日韩",
    duration: "41:00",
    description: "一间小小的咖啡屋，收留着城市里每个疲惫而温柔的灵魂。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20slice-of-life%20cover%2C%20a%20cozy%20cafe%20counter%20with%20warm%20hanging%20lights%2C%20soft%20bokeh%2C%20intimate%20nostalgic%20mood%2C%20dark%20moody%20background&width=640&height=360&seq=tv-10&orientation=landscape",
    publishDate: "2026-05-06",
    hot: 5760,
  },
  {
    id: "tv-11",
    title: "逆流而上",
    type: "电视剧",
    year: 2024,
    region: "内地",
    duration: "45:00",
    description: "泳池中的每一次转身与冲刺，都是一次对自我的超越。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sports%20drama%20cover%2C%20a%20swimmer%20in%20a%20dark%20pool%20with%20dramatic%20ripples%2C%20cool%20teal%20water%20with%20warm%20highlights%2C%20intense%20atmosphere&width=640&height=360&seq=tv-11&orientation=landscape",
    publishDate: "2026-04-18",
    hot: 6310,
  },
  {
    id: "tv-12",
    title: "家族风云",
    type: "电视剧",
    year: 2023,
    region: "港台",
    duration: "47:00",
    description: "烛光下的长桌旁，一个家族的兴衰与情感缓缓铺陈。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20saga%20cover%2C%20a%20grand%20dining%20hall%20at%20night%20with%20candlelight%2C%20warm%20amber%20tones%20with%20deep%20shadows%2C%20dramatic%20mood&width=640&height=360&seq=tv-12&orientation=landscape",
    publishDate: "2026-04-02",
    hot: 5890,
  },
  {
    id: "tv-13",
    title: "末日曙光",
    type: "电视剧",
    year: 2025,
    region: "欧美",
    duration: "50:00",
    description: "文明崩塌之后，幸存者们在废墟中寻找重新开始的可能。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20post-apocalyptic%20cover%2C%20a%20ruined%20city%20skyline%20at%20dawn%20with%20a%20lone%20survivor%2C%20warm%20orange%20sky%20with%20cool%20teal%20ruins%2C%20epic%20scale&width=640&height=360&seq=tv-13&orientation=landscape",
    publishDate: "2026-03-15",
    hot: 8340,
    featured: true,
  },
  {
    id: "tv-14",
    title: "山城故事",
    type: "电视剧",
    year: 2022,
    region: "内地",
    duration: "42:00",
    description: "依山而建的小城里，邻里之间的烟火气温暖着每一个黄昏。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20cover%2C%20a%20hillside%20town%20at%20dusk%20with%20layered%20rooftops%2C%20warm%20window%20lights%2C%20misty%20cool%20tones%2C%20atmospheric%20depth&width=640&height=360&seq=tv-14&orientation=landscape",
    publishDate: "2026-02-27",
    hot: 5320,
  },
  {
    id: "tv-15",
    title: "校园季",
    type: "电视剧",
    year: 2024,
    region: "日韩",
    duration: "38:00",
    description: "午后的阳光洒进教室，一段青涩而明亮的时光就此展开。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20series%20cover%2C%20a%20classroom%20with%20afternoon%20sunlight%20through%20windows%2C%20warm%20nostalgic%20tones%2C%20soft%20haze%2C%20gentle%20mood&width=640&height=360&seq=tv-15&orientation=landscape",
    publishDate: "2026-02-10",
    hot: 6080,
  },
  {
    id: "tv-16",
    title: "权谋之境",
    type: "电视剧",
    year: 2023,
    region: "欧美",
    duration: "53:00",
    description: "幽暗的大厅里，各方势力围绕着一张长桌暗中角力。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20political%20drama%20cover%2C%20a%20shadowy%20grand%20hall%20with%20a%20long%20table%2C%20dramatic%20sidelight%2C%20warm%20amber%20against%20deep%20teal%2C%20tense%20atmosphere&width=640&height=360&seq=tv-16&orientation=landscape",
    publishDate: "2026-01-28",
    hot: 6710,
  },
  {
    id: "tv-17",
    title: "平凡岁月",
    type: "电视剧",
    year: 2025,
    region: "内地",
    duration: "44:00",
    description: "厨房里升腾的蒸汽和清晨的光，记录着一个家的平凡日常。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20cover%2C%20an%20old%20kitchen%20with%20warm%20morning%20light%2C%20steam%20rising%20from%20a%20pot%2C%20nostalgic%20intimate%20mood%2C%20soft%20bokeh&width=640&height=360&seq=tv-17&orientation=landscape",
    publishDate: "2026-01-14",
    hot: 6150,
  },
  {
    id: "tv-18",
    title: "双面人生",
    type: "电视剧",
    year: 2024,
    region: "港台",
    duration: "46:00",
    description: "一个人的两面，在雨夜的窗影里渐渐显露出真实的轮廓。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20series%20cover%2C%20a%20split-lit%20portrait%20silhouette%20against%20a%20rainy%20window%2C%20teal%20and%20orange%20palette%2C%20mysterious%20tense%20mood&width=640&height=360&seq=tv-18&orientation=landscape",
    publishDate: "2026-01-02",
    hot: 7560,
  },
  {
    id: "tv-19",
    title: "未来都市",
    type: "电视剧",
    year: 2025,
    region: "欧美",
    duration: "49:00",
    description: "霓虹与高楼交织的都市里，科技与人性正在发生碰撞。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20series%20cover%2C%20a%20futuristic%20city%20at%20night%20with%20glowing%20towers%2C%20neon%20reflections%2C%20orange%20and%20teal%20lighting%2C%20epic%20scale&width=640&height=360&seq=tv-19&orientation=landscape",
    publishDate: "2025-12-20",
    hot: 8020,
  },
  {
    id: "tv-20",
    title: "花开时节",
    type: "电视剧",
    year: 2023,
    region: "内地",
    duration: "41:00",
    description: "春日花瓣铺满小径，两个人在最好的时节不期而遇。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20series%20cover%2C%20a%20blossom-lined%20path%20in%20spring%20light%2C%20soft%20warm%20tones%2C%20dreamy%20atmosphere%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=tv-20&orientation=landscape",
    publishDate: "2025-12-06",
    hot: 5590,
  },
  {
    id: "tv-21",
    title: "夜色温柔",
    type: "电视剧",
    year: 2024,
    region: "日韩",
    duration: "43:00",
    description: "天台上俯瞰万家灯火，两个人的故事在夜色中缓缓展开。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20cover%2C%20a%20couple%20silhouetted%20on%20a%20rooftop%20overlooking%20city%20lights%2C%20warm%20glow%20against%20cool%20night%2C%20romantic%20mood&width=640&height=360&seq=tv-21&orientation=landscape",
    publishDate: "2025-11-22",
    hot: 6040,
  },

  // ==================== 短视频 ====================
  {
    id: "short-01",
    title: "一分钟美食",
    type: "短视频",
    year: 2025,
    region: "内地",
    duration: "01:20",
    description: "一碗热气腾腾的面，用一分钟讲完从下锅到上桌的全部过程。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20food%20shot%20cover%2C%20a%20steaming%20bowl%20of%20noodles%20on%20a%20rustic%20wooden%20table%2C%20warm%20inviting%20light%2C%20shallow%20depth%20of%20field%2C%20appetizing%20mood&width=640&height=360&seq=short-01&orientation=landscape",
    publishDate: "2026-10-01",
    hot: 7820,
  },
  {
    id: "short-02",
    title: "街头滑板秀",
    type: "短视频",
    year: 2024,
    region: "欧美",
    duration: "00:58",
    description: "城市的广场就是舞台，一块滑板完成一次漂亮的腾空翻转。",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20skateboarding%20cover%2C%20a%20skater%20mid-air%20trick%20in%20an%20urban%20plaza%2C%20motion%20blur%2C%20warm%20golden%20hour%20light%2C%20dynamic%20low%20angle&width=640&height=360&seq=short-02&orientation=landscape",
    publishDate: "2026-09-26",
    hot: 6980,
  },
  {
    id: "short-03",
    title: "萌宠日常",
    type: "短视频",
    year: 2025,
    region: "内地",
    duration: "00:45",
    description: "一只猫在阳光下的窗台上打了个哈欠，治愈了一整个下午。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20pet%20cover%2C%20a%20fluffy%20cat%20lounging%20on%20a%20sunlit%20windowsill%2C%20soft%20warm%20light%2C%20shallow%20depth%20of%20field%2C%20gentle%20mood&width=640&height=360&seq=short-03&orientation=landscape",
    publishDate: "2026-09-18",
    hot: 8460,
    featured: true,
  },
  {
    id: "short-04",
    title: "旅行Vlog海岛",
    type: "短视频",
    year: 2024,
    region: "其他",
    duration: "02:10",
    description: "碧海蓝天与落日余晖，一段海岛慢旅行的完整记录。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20travel%20cover%2C%20a%20tropical%20island%20beach%20with%20turquoise%20water%2C%20golden%20sunset%20light%2C%20warm%20inviting%20tones%2C%20wide%20scenic%20shot&width=640&height=360&seq=short-04&orientation=landscape",
    publishDate: "2026-09-08",
    hot: 7120,
  },
  {
    id: "short-05",
    title: "手工教学",
    type: "短视频",
    year: 2025,
    region: "内地",
    duration: "03:05",
    description: "几样简单材料，跟着镜头一步步做出属于自己的小物件。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20craft%20cover%2C%20handmade%20crafts%20on%20a%20wooden%20workbench%2C%20warm%20soft%20light%2C%20tidy%20minimal%20composition%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-05&orientation=landscape",
    publishDate: "2026-08-28",
    hot: 5230,
  },
  {
    id: "short-06",
    title: "城市夜景延时",
    type: "短视频",
    year: 2023,
    region: "欧美",
    duration: "01:35",
    description: "用延时镜头记录一座城市从黄昏到深夜的灯火流转。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20cityscape%20cover%2C%20a%20nighttime%20skyline%20with%20light%20trails%2C%20long%20exposure%20glow%2C%20orange%20and%20teal%20tones%2C%20epic%20wide%20shot&width=640&height=360&seq=short-06&orientation=landscape",
    publishDate: "2026-08-14",
    hot: 6450,
  },
  {
    id: "short-07",
    title: "健身小课堂",
    type: "短视频",
    year: 2024,
    region: "内地",
    duration: "02:40",
    description: "十分钟在家就能完成的一组训练，帮你找回运动的节奏。",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20fitness%20cover%2C%20a%20dumbbell%20and%20mat%20in%20a%20dark%20gym%20with%20warm%20rim%20light%2C%20teal%20shadows%2C%20focused%20mood%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-07&orientation=landscape",
    publishDate: "2026-08-02",
    hot: 5780,
  },
  {
    id: "short-08",
    title: "咖啡拉花",
    type: "短视频",
    year: 2025,
    region: "日韩",
    duration: "01:12",
    description: "牛奶与咖啡相遇的那一刻，一杯普通的咖啡有了温度。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20coffee%20cover%2C%20latte%20art%20in%20a%20ceramic%20cup%20on%20a%20cafe%20counter%2C%20warm%20soft%20light%2C%20intimate%20mood%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-08&orientation=landscape",
    publishDate: "2026-07-22",
    hot: 6110,
  },
  {
    id: "short-09",
    title: "无人机航拍",
    type: "短视频",
    year: 2024,
    region: "欧美",
    duration: "02:25",
    description: "从空中俯瞰蜿蜒的河流与群山，换个角度看世界。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20aerial%20cover%2C%20a%20winding%20river%20through%20green%20mountains%20from%20above%2C%20soft%20morning%20light%2C%20epic%20wide%20composition&width=640&height=360&seq=short-09&orientation=landscape",
    publishDate: "2026-07-08",
    hot: 6890,
  },
  {
    id: "short-10",
    title: "街头音乐",
    type: "短视频",
    year: 2025,
    region: "内地",
    duration: "01:48",
    description: "傍晚的街角，一段随性的旋律吸引路人纷纷驻足。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20street%20cover%2C%20a%20musician%20playing%20guitar%20on%20a%20warmly%20lit%20evening%20street%2C%20bokeh%20lights%2C%20intimate%20mood&width=640&height=360&seq=short-10&orientation=landscape",
    publishDate: "2026-06-24",
    hot: 5560,
  },
  {
    id: "short-11",
    title: "收纳技巧",
    type: "短视频",
    year: 2023,
    region: "日韩",
    duration: "02:02",
    description: "几个简单的方法，让杂乱的空间重新变得整整齐齐。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20home%20cover%2C%20neatly%20organized%20shelves%20in%20a%20bright%20minimal%20room%2C%20warm%20soft%20light%2C%20clean%20tidy%20composition&width=640&height=360&seq=short-11&orientation=landscape",
    publishDate: "2026-06-10",
    hot: 4980,
  },
  {
    id: "short-12",
    title: "宠物训练",
    type: "短视频",
    year: 2024,
    region: "内地",
    duration: "01:30",
    description: "耐心的引导加上一点小零食，狗狗很快学会了新技能。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20dog%20cover%2C%20a%20dog%20learning%20a%20trick%20in%20a%20sunny%20park%2C%20warm%20golden%20light%2C%20joyful%20dynamic%20mood%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-12&orientation=landscape",
    publishDate: "2026-05-28",
    hot: 6240,
  },
  {
    id: "short-13",
    title: "极简生活",
    type: "短视频",
    year: 2025,
    region: "欧美",
    duration: "02:15",
    description: "一张桌子、一株绿植，用极简的方式找回生活的秩序感。",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20lifestyle%20cover%2C%20a%20simple%20desk%20with%20a%20plant%20and%20notebook%2C%20warm%20morning%20light%2C%20calm%20mood%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-13&orientation=landscape",
    publishDate: "2026-05-12",
    hot: 5420,
  },
  {
    id: "short-14",
    title: "手绘插画",
    type: "短视频",
    year: 2024,
    region: "内地",
    duration: "03:20",
    description: "从一张白纸到一幅成画，看插画师如何用色彩讲述故事。",
    cover: "https://readdy.ai/api/search-image?query=Creative%20art%20cover%2C%20an%20artist%20hand%20painting%20colorful%20illustration%2C%20warm%20soft%20light%2C%20vivid%20palette%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-14&orientation=landscape",
    publishDate: "2026-04-26",
    hot: 5870,
  },
  {
    id: "short-15",
    title: "城市骑行",
    type: "短视频",
    year: 2023,
    region: "港台",
    duration: "01:55",
    description: "骑车穿过黄昏的城市街道，风把一天的疲惫都吹散了。",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20cycling%20cover%2C%20a%20cyclist%20riding%20through%20a%20city%20street%20at%20golden%20hour%2C%20motion%20blur%2C%20warm%20light%2C%20dynamic%20angle&width=640&height=360&seq=short-15&orientation=landscape",
    publishDate: "2026-04-10",
    hot: 5290,
  },
  {
    id: "short-16",
    title: "烘焙日记",
    type: "短视频",
    year: 2025,
    region: "日韩",
    duration: "02:35",
    description: "面粉、黄油与烤箱的默契配合，一盘香甜出炉的全过程。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20baking%20cover%2C%20fresh%20bread%20and%20pastries%20on%20a%20rustic%20table%2C%20warm%20inviting%20light%2C%20appetizing%20mood%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=short-16&orientation=landscape",
    publishDate: "2026-03-28",
    hot: 6320,
  },
  {
    id: "short-17",
    title: "科技速览",
    type: "短视频",
    year: 2024,
    region: "欧美",
    duration: "01:40",
    description: "用一分钟快速了解这个月值得关注的新科技动态。",
    cover: "https://readdy.ai/api/search-image?query=Modern%20tech%20cover%2C%20sleek%20gadgets%20on%20a%20dark%20desk%20with%20cool%20rim%20light%2C%20orange%20accent%20glow%2C%20clean%20minimal%20composition&width=640&height=360&seq=short-17&orientation=landscape",
    publishDate: "2026-03-14",
    hot: 5760,
  },
  {
    id: "short-18",
    title: "街舞挑战",
    type: "短视频",
    year: 2025,
    region: "内地",
    duration: "01:05",
    description: "地下通道里的即兴斗舞，节奏和力量在瞬间爆发。",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20dance%20cover%2C%20a%20dancer%20mid-move%20in%20an%20urban%20underpass%2C%20dramatic%20rim%20light%2C%20motion%20blur%2C%20dynamic%20mood&width=640&height=360&seq=short-18&orientation=landscape",
    publishDate: "2026-02-26",
    hot: 6680,
  },
  {
    id: "short-19",
    title: "治愈系风景",
    type: "短视频",
    year: 2023,
    region: "其他",
    duration: "02:50",
    description: "清晨薄雾笼罩的湖面，一眼就让人安静下来的风景。",
    cover: "https://readdy.ai/api/search-image?query=Calm%20nature%20cover%2C%20a%20misty%20lake%20at%20sunrise%20with%20soft%20reflections%2C%20gentle%20warm%20light%2C%20serene%20atmosphere%2C%20wide%20shot&width=640&height=360&seq=short-19&orientation=landscape",
    publishDate: "2026-02-08",
    hot: 5120,
  },
  {
    id: "short-20",
    title: "数码评测",
    type: "短视频",
    year: 2024,
    region: "内地",
    duration: "03:15",
    description: "从手感到性能，全方位聊聊这台新设备到底值不值得入手。",
    cover: "https://readdy.ai/api/search-image?query=Modern%20tech%20cover%2C%20a%20laptop%20and%20headphones%20under%20cool%20studio%20light%2C%20subtle%20orange%20accent%2C%20clean%20minimal%20mood&width=640&height=360&seq=short-20&orientation=landscape",
    publishDate: "2026-01-20",
    hot: 5980,
  },
  {
    id: "short-21",
    title: "美食探店",
    type: "短视频",
    year: 2025,
    region: "港台",
    duration: "02:20",
    description: "穿进热闹的夜市，寻找藏在巷子里的地道好味道。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20food%20cover%2C%20a%20lively%20hawker%20street%20with%20glowing%20stalls%20at%20night%2C%20warm%20light%2C%20inviting%20atmosphere%2C%20bokeh&width=640&height=360&seq=short-21&orientation=landscape",
    publishDate: "2026-01-06",
    hot: 7340,
  },
];

export const videoTypes: ("电影" | "电视剧" | "短视频")[] = ["电影", "电视剧", "短视频"];

export const regionOptions: string[] = ["内地", "港台", "欧美", "日韩", "其他"];

export const yearOptions: number[] = [2026, 2025, 2024, 2023, 2022, 2021];